import moment from 'moment/moment'

export default function (response, fileName, extension) {
  if (extension) {
    fileName = fileName + '_' + moment().format('YYYYMMDDHHmmss') + '.' + extension
  }
  if (!response || !response.data || !fileName) {
    return
  }

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName)
  } else {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([response.data]))
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  }
}
